import { Controller } from "@hotwired/stimulus"
import { destroy } from "@rails/request.js"

export default class extends Controller {
  static values = { 
    batchId: Number,
    service: String
  }
  static targets = ["endSection", "endDateField", "repeatTimesField"]

  async removeSingleEvent(event) {
    event.preventDefault()
    const appointmentId = event.target.dataset.appointmentId
    
    if (appointmentId && confirm('Deseja remover apenas esta aula?')) {
      try {
        await destroy(`/admin/${this.serviceValue}/batches/${this.batchIdValue}/lesson_schedules/${appointmentId}`, {
          responseKind: "turbo-stream"
        })
      } catch (error) {
        console.error('Erro ao remover aula:', error)
      }
    }
  }

  async removeAllEvents(event) {
    event.preventDefault()
    const batchScheduleId = event.target.dataset.batchScheduleId
    
    if (batchScheduleId && confirm('Deseja remover todas as aulas desta matéria?')) {
      try {
        await destroy(`/admin/${this.serviceValue}/batches/${this.batchIdValue}/lesson_schedules/${batchScheduleId}/destroy_all`, {
          responseKind: "turbo-stream"
        })
      } catch (error) {
        console.error('Erro ao remover todas as aulas:', error)
      }
    }
  }

  async removeFutureEvents(event) {
    event.preventDefault()
    const appointmentId = event.target.dataset.appointmentId
    
    if (appointmentId && confirm('Deseja remover esta e todas as futuras aulas?')) {
      try {
        await destroy(`/admin/${this.serviceValue}/batches/${this.batchIdValue}/lesson_schedules/${appointmentId}/destroy_future`, {
          responseKind: "turbo-stream"
        })
      } catch (error) {
        console.error('Erro ao remover aulas futuras:', error)
      }
    }
  }

  closeSchedulerModal() {
    const turboFrame = document.querySelector('#turbo-scheduler-modal')
    if (turboFrame) {
      turboFrame.innerHTML = ''
    }
  }

  toggleEndSection(event) {
    const repeatType = event.target.value
    const hasRepeatType = repeatType && repeatType !== ""
    
    this.endSectionTargets.forEach(target => {
      if (hasRepeatType) {
        target.style.display = "block"
      } else {
        target.style.display = "none"
      }
    })
  }

  toggleEndFields(event) {
    const selectedValue = event.target.value

    this.endDateFieldTargets.forEach(field => field.disabled = true)
    this.repeatTimesFieldTargets.forEach(field => field.disabled = true)

    if (selectedValue === "on_date") {
      this.endDateFieldTargets.forEach(field => field.disabled = false)
    } else if (selectedValue === "after_occurrences") {
      this.repeatTimesFieldTargets.forEach(field => field.disabled = false)
    }
  }
}